export const TABLEADDED         = "TableSlice/added";
export const TABLELOADED        = "TableSlice/loaded";
export const TABLETIME          = "TableSlice/time";
export const TABLEREMOVED       = "TableSlice/removed";


export const BOOKINGLOADED      = "TableSlice/bookingLoaded";
export const TABLEBOOKED        = "TableSlice/booked";
export const TABLEUPDATED       = "TableSlice/bookingUpdated";
export const TABLESEARCH        = "TableSlice/searchbookedinfo";
export const CLOSESEARCH        = "TableSlice/closesearchbookedinfo";
export const DELETEBOOKEDINFO   = "TableSlice/deletebookedinfo";